import React from 'react';
import MainDashboardPageStyles from "./MainDashboardPage.module.css";
import { CgArrowLongLeft } from "react-icons/cg";
import { RiMenu2Line } from "react-icons/ri";
import {useMediaQuery} from 'react-responsive';

const DashboardNavBar = ({ sethamburgerMenu }) => {
    const isTablet = useMediaQuery({
        query: '(max-width: 768px)'
    })

    return (
        <div className={MainDashboardPageStyles.DashboardNavbarHam}>
            <p onClick={() => sethamburgerMenu("active")} className={MainDashboardPageStyles.DashboardNavbarHamIcon}>{isTablet && <RiMenu2Line />}</p>
            <div className={MainDashboardPageStyles.DashboardNavbar}>
                <p className={MainDashboardPageStyles.DashboardNavbarIcon}><CgArrowLongLeft /></p>
                <p className={MainDashboardPageStyles.DashboardNavbarText}>Sign out</p>
            </div>
        </div>
    )
}

export default DashboardNavBar
